import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "application-tabs__question" };
var _hoisted_2 = { class: "application-tabs__question-text" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ApplicationTabContent',
    props: {
        questionText: {},
        applicationData: {},
        requiredFields: {}
    },
    setup: function (__props) {
        var props = __props;
        var isNextDisabled = computed(function () {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return props.requiredFields.some(function (field) {
                if (field === 'email') {
                    return !emailPattern.test(props.applicationData.email);
                }
                return !props.applicationData[field];
            });
        });
        return function (_ctx, _cache) {
            var _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.questionText), 1),
                _renderSlot(_ctx.$slots, "default"),
                _createVNode(_component_el_button, {
                    class: "application-tabs__button accept-button",
                    color: "#013766",
                    onClick: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('next')); }),
                    disabled: isNextDisabled.value
                }, {
                    default: _withCtx(function () { return _cache[1] || (_cache[1] = [
                        _createTextVNode(" Ответить ")
                    ]); }),
                    _: 1
                }, 8, ["disabled"])
            ]));
        };
    }
});
